<template>
  <master-main
    :dataBadges="[
      {
        columnLabel: $t('common_words.company'),
        data: 'businesses',
        property: 'name',
        minWidth: 220,
      },
      {
        columnLabel: $t('common_words.farm'),
        data: 'farms',
        property: 'name',
        minWidth: 160,
      },
    ]"
    :route="getModuleRoute"
    :showExportTables="false"
    :tableProperties="tableProperties"
    @closeModal="handleCloseModal"
    @openModal="handleOpenModal"
    @refresh="refresh"
    @showHideLoading="showHideLoading"
    @showNotification="notifyVue"
    ref="masterMain"
  >
    <template slot="dialogForm">
      <edit-or-create-tablet
        :syncDialog="modals"
        @addEdit="addEdit"
        @closeModal="handleCloseModal"
        @showHideLoading="showHideLoading"
        @showNotification="notifyVue"
        ref="editCreate"
      />
    </template>
  </master-main>
</template>

<script>
import EditCreate from './EditCreate.vue';
import MasterMain from 'src/components/Layouts/Masters/MasterMain.vue';
import MixinAlert from 'src/mixins/mixin-alert';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinMain from 'src/mixins/master/mixin-main';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinWithDialog from 'src/mixins/master/mixin-with-dialog';
import ScaleTable from './scale-table';

export default {
  name: 'Scale',
  components: { MasterMain, [EditCreate.name]: EditCreate },
  mixins: [
    MixinAlert,
    MixinLoading,
    MixinMain,
    MixinPermissions,
    MixinWithDialog,
  ],
  data() {
    return {
      tableProperties: {},
    };
  },
  computed: {
    getModuleRoute() {
      return 'scales/tablets';
    },
    buildTableProperties() {
      return {
        tableColumns: [...ScaleTable().tableColumns],
        auditModel: 'scale',
        effectTags: 'dark',
        widthColumnStatus: 160,
        defaultSort: { prop: 'name', order: 'ascending' },
      };
    },
  },
};
</script>
